// extracted by mini-css-extract-plugin
export var borderTop = "_t-3";
export var linkIcon = "_t-5";
export var linkIconSm = "_t-6";
export var linkOutCard = "_t-7 _t-4";
export var linkRow = "_t-2";
export var pageContainer = "_t-1";
export var providerIcon = "_t-8";
export var roundedBorder = "_t-4";
export var settingsContent = "_t-0";